import React from "react";

import { Steps as AntSteps, StepsProps as AntStepsProps } from "antd";

import { useAppType } from "utils";

import { ErrorBoundary } from "components";

export type StepsProps = AntStepsProps;
export const Steps = ({ ...props }: StepsProps) => {
  const { mobile } = useAppType();

  const itemsMobile = props.items?.map(() => ({}));

  const itemsToDisplay = mobile ? itemsMobile : props.items;

  return (
    <ErrorBoundary>
      <AntSteps {...props} size={mobile ? "small" : props.size} items={itemsToDisplay} />
    </ErrorBoundary>
  );
};
